import axios from 'axios';
import { ImageFile } from 'react-dropzone';

const CelsiusClaimService = {
  getClaim: () =>
    axios.get('/api/celsius/requests'),
  postClaim: () =>
    axios.post(
      '/api/celsius/requests',
      undefined
    ),
  uploadScreenshot: (data: unknown, apiKey: string) =>
    axios.patch(
      '/api/celsius/requests',
      { screenshots: data, api_key: apiKey }
    ),
};

Object.freeze(CelsiusClaimService);
export default CelsiusClaimService;
